import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { baseAPI } from '../../../config';
import { toast } from 'react-toastify';
import ModalSimple from '../../ModalSimple';
import CreateAssignmentForm from './CreateAssignmentForm';
import { PlusIcon } from '@heroicons/react/24/outline';

const CreateAssignmentModal = ({ expedientId, onAssignmentCreated }) => {
  const [submitting, setSubmitting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [resetTrigger, setResetTrigger] = useState(0);

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      setResetTrigger(prev => prev + 1);
    }
  }, [isOpen]);

  const handleFormSubmit = async assignmentData => {
    try {
      setSubmitting(true);
      const token = localStorage.getItem('token');

      const response = await axios.post(`${baseAPI}/assignments`, assignmentData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success('Gestión creada');
      setIsOpen(false);

      if (onAssignmentCreated) {
        onAssignmentCreated(response.data.assignment);
      }
    } catch (error) {
      console.error('Error creating assignment:', error);
      if (error.response?.status === 401) {
        toast.error('Sesión expirada. Por favor, inicia sesión nuevamente');
      } else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error('Error al crear el assignment');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className='p-1.5 text-blue-600 hover:text-blue-700 hover:bg-blue-50 rounded-lg transition-colors'
        title='Crear nuevo assignment'
        aria-label='Crear nuevo assignment'
      >
        <PlusIcon className='w-5 h-5' />
      </button>

      <ModalSimple
        id='create-assignment-modal'
        title='Nueva gestión'
        show={isOpen}
        onClose={() => setIsOpen(false)}
        size='lg'
      >
        {isOpen && (
          <CreateAssignmentForm
            expedientId={expedientId}
            onSubmit={handleFormSubmit}
            onCancel={() => setIsOpen(false)}
            isSubmitting={submitting}
            resetTrigger={resetTrigger}
          />
        )}
      </ModalSimple>
    </>
  );
};

export default CreateAssignmentModal;
